
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/youtube",
      function () {
        return require("private-next-pages/use-cases/youtube.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/youtube"])
      });
    }
  